export const i18nEn = {
  label: {
    metrics: 'Metrics',
    search: 'Search',
    dark: 'Dark',
    light: 'Light',
  },
  action: {
    reload: 'Reload',
    hide_sidebar: 'Hide sidebar',
    ok: 'Ok',
    cancel: 'Cancel',
    select_all: 'Select all'
  }
};
